<template>
    <div class="container">
        <van-row class="field_row">
            <van-col span="3" class="icon_image">
                <img :src="props.leftImage" alt="">
            </van-col>
            <van-col span="11" class="label">{{ props.labelText }}
            </van-col>
            <van-col span="10" class="content">
                {{ props.content }}
            </van-col>
        </van-row>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'

const props = defineProps({
    labelText: {
        type: String,
        default: ''
    },
    leftImage: {
        type: String,
    },
    content: {
        type: String,
    },
})

</script>
<style scoped>
.container {
    padding: 5px 0;
}

.label {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.85);
    padding: 7.5px 5px;
}

.field_row {
    padding: 10px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 30px;
}

.icon_image {
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon_image img {
    width: 18px;
    opacity: 0.5;
}

.content {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 15px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
}
</style>